import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, getDetail, remove, update, add, setting, datasource } from "@/api/system/tenant";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: true,
      box: false,
      datasourceBox: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogWidth: 900,
        dialogClickModal: false,
        column: [{
          label: "租户ID",
          prop: "tenantId",
          width: 100,
          search: true,
          addDisplay: false,
          editDisplay: false,
          span: 24,
          rules: [{
            required: true,
            message: "请输入租户ID",
            trigger: "blur"
          }]
        }, {
          label: "租户名称",
          prop: "tenantName",
          search: true,
          width: 180,
          span: 24,
          rules: [{
            required: true,
            message: "请输入参数名称",
            trigger: "blur"
          }]
        }, {
          label: "联系人",
          prop: "linkman",
          width: 100,
          search: true,
          rules: [{
            required: true,
            message: "请输入联系人",
            trigger: "blur"
          }]
        }, {
          label: "联系电话",
          prop: "contactNumber",
          width: 150
        }, {
          label: "联系地址",
          prop: "address",
          span: 24,
          minRows: 2,
          type: "textarea",
          hide: true
        }, {
          label: "账号额度",
          prop: "accountNumber",
          width: 90,
          slot: true,
          addDisplay: false,
          editDisplay: false
        }, {
          label: "过期时间",
          prop: "expireTime",
          width: 180,
          slot: true,
          addDisplay: false,
          editDisplay: false
        }, {
          label: "绑定域名",
          prop: "domain",
          span: 24
        }, {
          label: "公司标题",
          prop: "companyTitle",
          span: 24,
          minRows: 2,
          type: "input"
        }, {
          label: "系统背景",
          prop: "backgroundUrl",
          type: 'upload',
          listType: 'picture-img',
          action: '/api/blade-resource/oss/endpoint/put-file',
          propsHttp: {
            res: 'data',
            url: 'link'
          },
          span: 24
        }, {
          label: "公司logo",
          prop: "companyLogo",
          type: 'upload',
          listType: 'picture-img',
          action: '/api/blade-resource/oss/endpoint/put-file',
          propsHttp: {
            res: 'data',
            url: 'link'
          },
          span: 24
        }]
      },
      data: [],
      settingForm: {},
      settingOption: {
        column: [{
          label: "账号额度",
          prop: "accountNumber",
          type: "number",
          span: 24
        }, {
          label: "过期时间",
          prop: "expireTime",
          type: "date",
          format: "yyyy-MM-dd hh:mm:ss",
          valueFormat: "yyyy-MM-dd hh:mm:ss",
          span: 24
        }]
      },
      datasourceForm: {},
      datasourceOption: {
        column: [{
          label: "数据源",
          prop: "datasourceId",
          search: true,
          span: 24,
          type: "select",
          dicUrl: "/api/blade-develop/datasource/select",
          props: {
            label: "name",
            value: "id"
          },
          rules: [{
            required: true,
            message: "请选择数据源",
            trigger: "blur"
          }]
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userInfo", "permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.tenant_add, false),
        viewBtn: this.vaildData(this.permission.tenant_view, false),
        delBtn: this.vaildData(this.permission.tenant_delete, false),
        editBtn: this.vaildData(this.permission.tenant_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
    tenantId: function tenantId() {
      return this.selectionList[0].tenantId;
    }
  }),
  methods: {
    rowSave: function rowSave(row, done, loading) {
      var _this = this;

      add(row).then(function () {
        _this.onLoad(_this.page);

        _this.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this2 = this;

      update(row).then(function () {
        _this2.onLoad(_this2.page);

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this3 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this4 = this;

      if (["view"].includes(type)) {
        getDetail(this.form.id).then(function (res) {
          var data = res.data.data;

          if (!(data.accountNumber > 0)) {
            data.accountNumber = "不限制";
          }

          if (!data.expireTime) {
            data.expireTime = "不限制";
          }

          _this4.form = data;
        });
      }

      done();
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this5 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this5.ids);
      }).then(function () {
        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });

        _this5.$refs.crud.toggleSelection();
      });
    },
    handleSetting: function handleSetting() {
      var _this6 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      if (this.selectionList.length === 1) {
        getDetail(this.selectionList[0].id).then(function (res) {
          var data = res.data.data;
          _this6.settingForm.accountNumber = data.accountNumber;
          _this6.settingForm.expireTime = data.expireTime;
        });
      } else {
        this.settingForm.accountNumber = -1;
        this.settingForm.expireTime = '';
      }

      this.box = true;
    },
    handleDatasource: function handleDatasource() {
      var _this7 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      if (this.selectionList.length !== 1) {
        this.$message.warning("只能选择一条数据");
        return;
      }

      getDetail(this.selectionList[0].id).then(function (res) {
        var data = res.data.data;
        _this7.datasourceForm.datasourceId = data.datasourceId;
      });
      this.datasourceBox = true;
    },
    handleSubmit: function handleSubmit(form, done, loading) {
      var _this8 = this;

      setting(this.ids, form).then(function () {
        _this8.onLoad(_this8.page);

        _this8.$message({
          type: "success",
          message: "配置成功!"
        });

        done();
        _this8.box = false;
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    handleDatasourceSubmit: function handleDatasourceSubmit(form, done, loading) {
      var _this9 = this;

      datasource(this.tenantId, form.datasourceId).then(function () {
        _this9.$message({
          type: "success",
          message: "配置成功!"
        });

        done();
        _this9.datasourceBox = false;
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this10 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(function (res) {
        var data = res.data.data;
        _this10.page.total = data.total;
        _this10.data = data.records;
        _this10.loading = false;

        _this10.selectionClear();
      });
    }
  }
};